import React from 'react';
import { IReport } from '../../../../common/sharedTypes';
import Loader from 'react-loader-spinner';
import DataTable from '../../../DataTable';
import { Button, Col, Form, Row } from 'react-bootstrap';
import ReactDOM from 'react-dom';
import moment from 'moment';
import { IInvolvedPartyProps, InvolvedParty } from './InvolvedParty';
import { InvolvedPartyInfo } from '../business-objects/common';
import ViewOriginalReportButton from '../../../shared/ViewOriginalReport/ViewOriginalReportButton';

interface IKeywordMatchSearchResultsStateProps {
  matchResults: IReport[];
  onChangeKeywordMatchSearchResults: (rowData: IReport) => void;
}

interface IKeywordMatchSearchResultsActionProps {}

export interface IKeywordMatchSearchResultsProps
  extends IKeywordMatchSearchResultsStateProps,
    IKeywordMatchSearchResultsActionProps {}

export class KeywordMatchSearchResults extends React.Component<
  IKeywordMatchSearchResultsProps,
  IKeywordMatchSearchResultsStateProps
> {
  componentDidMount() {
    console.log(this.props.matchResults);
  }

  render() {
    const columns = [
      {
        title: '',
        data: 'id',
      },
      {
        title: 'Crash Key',
        data: 'keywords.originalCrashKey',
      },
      {
        title: 'Crash Date',
        data: 'keywords.dateOfCrash',
      },
      {
        title: 'County',
        data: 'keywords.county.description',
      },
      {
        title: 'Names',
        data: 'keywords.involvedParties',
      },
      {
        title: 'Agency',
        data: 'keywords.agency.name',
      },
    ];

    const options = {
      className: 'table table-striped table-bordered',
      dom: 'frtipB',
    };

    const columnDefs = [
      {
        targets: 0,
        width: '75px',
        createdCell: (td, cellData, rowData) =>
          ReactDOM.render(
            <div>
              <Button
                variant='outline-primary'
                size='sm'
                data-id={cellData}
                onClick={(e) =>
                  this.props.onChangeKeywordMatchSearchResults(rowData)
                }
              >
                Copy
              </Button>
              {'  '}
              <ViewOriginalReportButton
                documentId={rowData.keywords.documentId}
              />
            </div>,
            td
          ),
      },
      {
        targets: 2,
        render: function (data) {
          return moment(data).format('lll');
        },
      },
      {
        targets: 4,
        width: '150px',
        createdCell: (td, cellData, rowData) =>
          ReactDOM.render(
            <ul>
              {rowData.keywords.involvedParties.map((x) => {
                return (
                  <li key={x.id}>
                    {x.firstName} {x.lastName} {x.businessName}
                  </li>
                );
              })}
            </ul>,
            td
          ),
      },
    ];

    return (
      this.props.matchResults &&
      this.props.matchResults.length > 0 && (
        <div>
          {/* <Loader
            type='ThreeDots'
            color='#00BFFF'
            height={50}
            width={50}
            timeout={30000} //3 secs
          /> */}
          <DataTable
            id={'tblKeywordsMatchResults' + Math.random().toString().substr(2, 5)}
            data={this.props.matchResults}
            searching={false}
            columns={columns}
            columnDefs={columnDefs}
            actionsColumn='first'
            select={false}
            pageLength={5}
            {...options}
          />
        </div>
      )
    );
  }
}
